/**
 * Copyright (c) 2026, CheckPlus Limited
 */
import React, { Component } from "react";
import "./CnContact.css";
import { Link } from "react-router-dom";
import { renderHomePageHeader } from "../../assets/component/renderHomePageHeader.js";
import { Helmet } from "react-helmet";
import HomepageMenuCn from "../../assets/component/HomepageMenuCn/HomepageMenuCn.js";

class CnContact extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
    };
    this.showModal = this.showModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }
  componentDidMount() {
    window.scrollTo(0, 0);
  }
  showModal() {
    this.setState({
      showModal: true,
    });
  }

  closeModal() {
    this.setState({
      showModal: false,
    });
  }
  render() {
    return (
      <div className="CnContact-view">
        <Helmet>
          <title>联络我们 - CheckPlus</title>
        </Helmet>
        {!!this.state.showModal && (
          <HomepageMenuCn closeModal={this.closeModal} />
        )}

        {renderHomePageHeader(this)}

        <div className="CnContact-first">
          <div className="CnContact-heading">联络我们</div>

          <div className="CnContact-centerContainer">
            <a className="CnContact-option" href="mailto:help@check.plus">
              <div className="CnContact-pic">
                <div className="CnContact-email"></div>
              </div>
              <div className="CnContact-name">
                <strong>电子邮件</strong>
              </div>
            </a>

            <a
              className="CnContact-option"
              href="https://wa.me/message/WJ4IE7JQ2FTMP1"
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="CnContact-pic">
                <div className="CnContact-qr"></div>
              </div>
              <div className="CnContact-name">
                <strong>WhatsApp</strong>
              </div>
            </a>
          </div>
        </div>

        <div className="CnContact-footer">
          <div className="CnContact-footerNav">
            <Link to="/CnTeam">
              <div className="CnContact-footerNavItem">创办人的故事</div>
            </Link>
            <Link to="/CnFaq">
              <div className="CnContact-footerNavItem">常见问题</div>
            </Link>
            <Link to="/CnContact">
              <div className="CnContact-footerNavItem">联络我们</div>
            </Link>

            <Link to="/CnPrivacyPolicy">
              <div className="CnContact-footerNavItem">私隐政策</div>
            </Link>

            <Link to="/CnTerms">
              <div className="CnContact-footerNavItem">使用条款</div>
            </Link>
          </div>

          <div className="CnContact-footer_text">
            香港九龙油塘四山街 11 号
            <br />
            华利工业大厦5楼A室
            <br />
            <p />
            Copyright © 2026 CheckPlus Ltd. 保留一切权利。
          </div>
        </div>
      </div>
    );
  }
}

export default CnContact;
